import { render, staticRenderFns } from "./SystemCompare.vue?vue&type=template&id=268bf625&scoped=true"
import script from "./SystemCompare.vue?vue&type=script&lang=js"
export * from "./SystemCompare.vue?vue&type=script&lang=js"
import style0 from "./SystemCompare.vue?vue&type=style&index=0&id=268bf625&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268bf625",
  null
  
)

export default component.exports